import React from "react";

const User_Input_Strings = () => {
  return (
    <div>
      <h1>User_Input_Strings Component</h1>
      <p>Content for User_Input_Strings goes here...</p>
    </div>
  );
};

export default User_Input_Strings;
